import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const css = `
.ok-page{min-height:100vh;display:flex;align-items:center;justify-content:center;
  background:#f4f5fb;font-family:'Segoe UI',system-ui,sans-serif;position:relative;overflow:hidden;padding:16px}
.ok-light{position:fixed;width:420px;height:420px;border-radius:50%;pointer-events:none;
  background:radial-gradient(circle,rgba(124,108,240,.22),transparent 65%);
  transform:translate(-50%,-50%);left:50%;top:40%;transition:left .25s ease-out,top .25s ease-out}
.ok-card{position:relative;width:100%;max-width:420px;background:#fff;border-radius:28px;
  padding:44px 34px 36px;text-align:center;box-shadow:0 20px 60px rgba(60,50,140,.12)}
.ok-badge{width:72px;height:72px;margin:0 auto 26px;border-radius:20px;border:2px solid #6c5ce7;
  background:#f6f4ff;display:flex;align-items:center;justify-content:center;
  transform:rotate(-14deg);box-shadow:0 0 0 6px rgba(108,92,231,.12)}
.ok-badge span{transform:rotate(14deg);font-size:2rem;color:#6c5ce7;font-weight:800}
.ok-card h2{margin:0 0 12px;font-size:1.55rem;font-weight:800;color:#1b1b3a}
.ok-card p{margin:0 0 28px;font-size:.88rem;color:#7b7f99;line-height:1.65}
.ok-card p strong{color:#d97706}
.ok-btn{padding:13px 30px;border-radius:14px;border:none;background:#6c5ce7;color:#fff;
  font-size:.9rem;font-weight:700;cursor:pointer;font-family:inherit;
  transition:transform .15s,box-shadow .15s}
.ok-btn:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(108,92,231,.35)}
.ok-btn:focus-visible{outline:3px solid rgba(108,92,231,.4);outline-offset:3px}
@media (prefers-reduced-motion:reduce){.ok-light{transition:none}.ok-btn{transition:none}}
`;

export default function OTPSuccess() {
  const navigate = useNavigate();
  const lightRef = useRef(null);

  useEffect(() => {
    const move = (e) => {
      if (!lightRef.current) return;
      lightRef.current.style.left = e.clientX + "px";
      lightRef.current.style.top = e.clientY + "px";
    };
    window.addEventListener("pointermove", move);
    return () => window.removeEventListener("pointermove", move);
  }, []);

  return (
    <div className="ok-page">
      <style>{css}</style>
      <div className="ok-light" ref={lightRef} />

      <main className="ok-card">
        <div className="ok-badge"><span>✓</span></div>

        <h2>Email vérifié !</h2>
        <p>
          Votre adresse email a été vérifiée avec succès.<br />
          Votre compte est maintenant <strong>en attente d'activation</strong>{" "}
          par l'administrateur.<br /><br />
          Vous recevrez un email de confirmation dès que votre compte sera activé.
        </p>

        <button className="ok-btn" onClick={() => navigate("/login")}>
          Retour à la connexion
        </button>
      </main>
    </div>
  );
}